<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a href="/" class="navbar-item">
        <img src="../assets/wha.webp" alt="WHA Logo">
        &nbsp;World Health Ambassador
      </a>

      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" @click="onclickBurgerMenu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div v-if="isLoggedIn" class="navbar-menu" @click="onclickBurgerMenu">
      <div class="navbar-start">
        <router-link class="navbar-item" :to="{ name: 'home' }">Home</router-link>
        <router-link class="navbar-item" :to="{ name: 'profile' }">Profile</router-link>
        <router-link class="navbar-item" :to="{ name: 'missions' }">Missions</router-link>

        <div v-if="user.isAdmin" class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Admin
          </a>
          <div class="navbar-dropdown">
            <router-link class="navbar-item" :to="{ name: 'manage-missions' }">Manage Missions</router-link>
            <router-link class="navbar-item" :to="{ name: 'new-mission' }">Create Mission</router-link>
          </div>
        </div>
      </div>

      <div v-if="isLoggedIn" class="navbar-end">
        <a class="button is-outlined" @click="logOut">
          <span>Log Out</span>
        </a>
      </div>
    </div>
  </nav>

</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState([
      'isLoggedIn',
      'user',
    ]),
  },
  methods: {
    ...mapMutations([
      'logOut',
    ]),
    onclickBurgerMenu() {
      this.$el.querySelector('.navbar-menu').classList.toggle('is-active');
    },
  },
};
</script>
